define('app/config/filterTypes',{
	field: [{
		operator: 'BETWEEN_GTE_LTE',
		label: 'is between',
		inputMethod: 'between',
		type: 'INT'
	}, {
		operator: 'GT',
		label: 'is greater than',
		inputMethod: 'numeric',
		type: 'INT'
	}, {
		operator: 'GTE',
		label: 'is greater than or equal to',
		inputMethod: 'numeric',
		type: 'INT'
	}, {
		operator: 'LT',
		label: 'is less than',
		inputMethod: 'numeric',
		type: 'INT'
	}, {
		operator: 'EQ',
		label: 'equals',
		inputMethod: 'numeric',
		type: 'INT'
	}, {
		operator: 'LTE',
		label: 'is less than or equal to',
		inputMethod: 'numeric',
		type: 'INT'
	}, {
		operator: 'NEQ',
		label: 'does not equal',
		inputMethod: 'numeric',
		type: 'INT'
	}, {
		operator: 'IN',
		label: 'is one of',
		inputMethod: 'in',
		type: 'STR'
	}, {
		operator: 'HAS',
		label: 'contains one of',
		inputMethod: 'has',
		type: 'STR'
	}, {
		operator: 'EQ',
		label: 'equals',
		inputMethod: 'select',
		type: 'STR'
	}, {
		operator: 'CONTAINS',
		label: 'contains',
		inputMethod: 'text',
		type: 'STR'
	}, {
		operator: 'EQ',
		label: 'equals',
		inputMethod: 'select',
		type: 'ENUM'
	}, {
		operator: 'NEQ',
		label: 'does not equal',
		inputMethod: 'select',
		type: 'ENUM'
	}, {
		operator: 'IN',
		label: 'is one of',
		inputMethod: 'in',
		type: 'ENUM'
	}, {
		operator: 'NIN',
		label: 'is not one of',
		inputMethod: 'in',
		type: 'ENUM'
	}, {
		operator: 'ISNULL',
		label: 'is null',
		inputMethod: 'empty',
		type: 'ENUM'
	}, {
		operator: 'NISNULL',
		label: 'is not null',
		inputMethod: 'empty',
		type: 'ENUM'
	}, {
		operator: 'STARTSWITH',
		label: 'starts with',
		inputMethod: 'text',
		type: 'STR'
	}, {
		operator: 'ENDSWITH',
		label: 'ends with',
		inputMethod: 'text',
		type: 'STR'
	}, {
		operator: 'NIN',
		label: 'is not one of',
		inputMethod: 'in',
		type: 'STR'
	}, {
		operator: 'NEQ',
		label: 'does not equal',
		inputMethod: 'select',
		type: 'STR'
	}, {
		operator: 'NCONTAINS',
		label: 'does not contain',
		inputMethod: 'text',
		type: 'STR'
	}, {
		operator: 'NSTARTSWITH',
		label: 'does not start with',
		inputMethod: 'text',
		type: 'STR'
	}, {
		operator: 'NENDSWITH',
		label: 'does not end with',
		inputMethod: 'text',
		type: 'STR'
	}, {
		operator: 'LIKE',
		label: 'is like',
		inputMethod: 'text',
		type: 'STR'
	}, {
		operator: 'NLIKE',
		label: 'is not like',
		inputMethod: 'text',
		type: 'STR'
	}, {
		operator: 'ISNULL',
		label: 'is null',
		inputMethod: 'empty',
		type: 'STR'
	}, {
		operator: 'NISNULL',
		label: 'is not null',
		inputMethod: 'empty',
		type: 'STR'
	}, {
		operator: 'ISNULL',
		label: 'is null',
		inputMethod: 'empty',
		type: 'INT'
	}, {
		operator: 'NISNULL',
		label: 'is not null',
		inputMethod: 'empty',
		type: 'INT'
	}, {
		operator: 'BETWEEN_GTE_LTE',
		label: 'is between',
		inputMethod: 'between',
		type: 'DEC'
	}, {
		operator: 'GT',
		label: 'is greater than',
		inputMethod: 'numeric',
		type: 'DEC'
	}, {
		operator: 'GTE',
		label: 'is greater than or equal to',
		inputMethod: 'numeric',
		type: 'DEC'
	}, {
		operator: 'EQ',
		label: 'equals',
		inputMethod: 'numeric',
		type: 'DEC'
	}, {
		operator: 'NEQ',
		label: 'does not equal',
		inputMethod: 'numeric',
		type: 'DEC'
	}, {
		operator: 'LT',
		label: 'is less than',
		inputMethod: 'numeric',
		type: 'DEC'
	}, {
		operator: 'LTE',
		label: 'is less than or equal to',
		inputMethod: 'numeric',
		type: 'DEC'
	}, {
		operator: 'ISNULL',
		label: 'is null',
		inputMethod: 'empty',
		type: 'DEC'
	}, {
		operator: 'NISNULL',
		label: 'is not null',
		inputMethod: 'empty',
		type: 'DEC'
	}, {
		operator: 'BETWEEN_GTE_LTE',
		label: 'is between',
		inputMethod: 'between',
		type: 'CURRENCY'
	}, {
		operator: 'GT',
		label: 'is greater than',
		inputMethod: 'numeric',
		type: 'CURRENCY'
	}, {
		operator: 'GTE',
		label: 'is greater than or equal to',
		inputMethod: 'numeric',
		type: 'CURRENCY'
	}, {
		operator: 'EQ',
		label: 'equals',
		inputMethod: 'numeric',
		type: 'CURRENCY'
	}, {
		operator: 'NEQ',
		label: 'does not equal',
		inputMethod: 'numeric',
		type: 'CURRENCY'
	}, {
		operator: 'LT',
		label: 'is less than',
		inputMethod: 'numeric',
		type: 'CURRENCY'
	}, {
		operator: 'LTE',
		label: 'is less than or equal to',
		inputMethod: 'numeric',
		type: 'CURRENCY'
	}, {
		operator: 'ISNULL',
		label: 'is null',
		inputMethod: 'empty',
		type: 'CURRENCY'
	}, {
		operator: 'NISNULL',
		label: 'is not null',
		inputMethod: 'empty',
		type: 'CURRENCY'
	}, {
		operator: 'EQ',
		label: '',
		inputMethod: 'boolean',
		type: 'BOOL'
	}, {
		operator: 'BETWEEN_GTE_LTE',
		label: 'Date Range',
		inputMethod: 'date',
		type: 'DATETIME'
	}, {
		operator: 'EQ',
		label: 'Specific Date',
		inputMethod: 'date',
		type: 'DATETIME'
	}, {
		operator: 'LT',
		label: 'Before',
		inputMethod: 'date',
		type: 'DATETIME'
	}, {
		operator: 'GT',
		label: 'After',
		inputMethod: 'date',
		type: 'DATETIME'
	}, {
		operator: 'ROLLINGDATERANGE',
		label: 'Relative Date Range',
		inputMethod: 'rollingdate',
		type: 'DATETIME'
	}, {
		operator: 'ISNULL',
		label: 'is null',
		inputMethod: 'empty',
		type: 'DATETIME'
	}, {
		operator: 'NISNULL',
		label: 'is not null',
		inputMethod: 'empty',
		type: 'DATETIME'
	}, {
		operator: 'BETWEEN_GTE_LTE',
		label: 'Date Range',
		inputMethod: 'date',
		type: 'DATE'
	}, {
		operator: 'EQ',
		label: 'Specific Date',
		inputMethod: 'date',
		type: 'DATE'
	}, {
		operator: 'LT',
		label: 'Before',
		inputMethod: 'date',
		type: 'DATE'
	}, {
		operator: 'GT',
		label: 'After',
		inputMethod: 'date',
		type: 'DATE'
	}, {
		operator: 'ROLLINGDATERANGE',
		label: 'Relative Date Range',
		inputMethod: 'rollingdate',
		type: 'DATE'
	}, {
		operator: 'ISNULL',
		label: 'is null',
		inputMethod: 'empty',
		type: 'DATE'
	}, {
		operator: 'NISNULL',
		label: 'is not null',
		inputMethod: 'empty',
		type: 'DATE'
	}, {
		operator: 'BETWEEN_GTE_LTE',
		label: 'is between',
		inputMethod: 'timespan',
		type: 'TIMESPAN'
	}, {
		operator: 'GT',
		label: 'Greater than',
		inputMethod: 'timespan',
		type: 'TIMESPAN'
	}, {
		operator: 'LT',
		label: 'Less than',
		inputMethod: 'timespan',
		type: 'TIMESPAN'
	}, {
		operator: 'EQ',
		label: 'is equal to',
		inputMethod: 'timespan',
		type: 'TIMESPAN'
	}, {
		operator: 'NEQ',
		label: 'is not equal to',
		inputMethod: 'timespan',
		type: 'TIMESPAN'
	}, {
		operator: 'ISNULL',
		label: 'is null',
		inputMethod: 'timespan',
		type: 'TIMESPAN'
	}, {
		operator: 'NISNULL',
		label: 'is not null',
		inputMethod: 'timespan',
		type: 'TIMESPAN'
	}],
	compound: [{
		operator: 'AND',
		label: 'all'
	}, {
		operator: 'OR',
		label: 'any'
	}, {
		operator: 'NOT',
		label: 'none'
	}]
});

